import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numPhone'
})
export class NumPhonePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value.charAt(0) === "+") {
      let newVal = value.substring(3);
      newVal = "0" + newVal
      return newVal;
    } else {
      return value;
    }
  }

}
